<template>
  <div>
    <div :style="{ marginBottom: '1.5rem' }">
      <el-row
        type="flex"
        :gutter="16"
        :style="{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginBottom: '1rem',
          fontSize: '1rem',
          fontWeight: 'bold'
        }"
      >
        <el-col :md="14">
          <label :class="$style.label">ยอดเงิน</label>
        </el-col>
        <el-col :md="10" :style="{ textAlign: 'right' }">
          {{ amount | $_number_formattedNumber }}
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="16"
        :style="{ flexWrap: 'wrap', marginBottom: '1rem' }"
      >
        <el-col
          :md="8"
          :style="{
            display: 'flex',
            alignItems: 'center',
            maxHeight: '2.5rem'
          }"
        >
          <label :class="$style.label">ส่วนลด</label>
        </el-col>
        <el-col :md="16">
          <NumberInput
            v-model="localDiscount"
            :min="0"
            :max="100"
            :class="[$style.paymentInput, elementUiStyles.numberInput]"
          ></NumberInput>
          <div
            :style="{
              color: '#d0021b',
              textAlign: 'right',
              marginTop: '0.25rem'
            }"
          >
            * ส่วนลด ลดได้ไม่เกิน 100 บาท
          </div>
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="16"
        :style="{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginBottom: '0.5rem',
          fontSize: '1.25rem',
          fontWeight: 'bold'
        }"
      >
        <el-col :md="14">
          <label>รวม (บาท)</label>
        </el-col>
        <el-col :md="10" :style="{ textAlign: 'right' }">
          {{ total | $_number_formattedNumber }}
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="16"
        :style="{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          marginBottom: '0.5rem',
          fontSize: '1rem',
          fontWeight: 'bold'
        }"
      >
        <el-col :md="14">
          <label>ค่าธรรมเนียม</label>
        </el-col>
        <el-col :md="10" :style="{ textAlign: 'right' }">
          {{ fee | $_number_formattedNumber }}
        </el-col>
      </el-row>
      <el-row
        type="flex"
        :gutter="16"
        :style="{
          flexWrap: 'wrap',
          alignItems: 'baseline',
          fontSize: '1.25rem',
          fontWeight: 'bold'
        }"
      >
        <el-col :md="14" :style="{ fontSize: '1rem' }">
          <label>
            ยอดชำระรวมค่าธรรมเนียม (บาท)
          </label>
        </el-col>
        <el-col :md="10" :style="{ textAlign: 'right' }">
          {{ totalWithCharge | $_number_formattedNumber }}
        </el-col>
      </el-row>
    </div>

    <PaymentSummary :style="{ marginBottom: '1.5rem' }">
      <PaymentSummaryItem title="ได้รับแล้ว">
        ฿ {{ receivedAmount | $_number_formattedNumber }}
      </PaymentSummaryItem>
      <PaymentSummaryItem title="เงินทอน/เงินคืน">
        <span :style="{ color: '#d6121e' }">
          ฿ {{ changeAmount | $_number_formattedNumber }}
        </span>
      </PaymentSummaryItem>
    </PaymentSummary>

    <div
      :style="{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '1.5rem'
      }"
    >
      <el-checkbox v-model="localInvoice" border
        >ออกบิล Vat ให้ลูกค้า</el-checkbox
      >
    </div>

    <PaymentMethod
      title="ช่องทางที่รับชำระ"
      :style="{ marginBottom: '3rem' }"
      @add="addMethod"
    >
      <PaymentMethodItem
        v-for="(item, index) in methods"
        :key="index"
        :index="index"
        :method.sync="item.method"
        :ref-code.sync="item.ref"
        :amount.sync="item.amount"
        :fee.sync="item.fee"
        @remove="removeMethod(index)"
      ></PaymentMethodItem>
    </PaymentMethod>

    <div>
      <h2>แนบหลักฐาน/สลิป</h2>
      <FileUpload
        :uploading="uploading"
        :style="{ marginBottom: '1rem' }"
        @change="upload"
      ></FileUpload>
      <FilePreviewList>
        <FilePreviewListItem v-for="(item, index) in evidences" :key="index">
          <FilePreview
            :src="item.url"
            :style="{ width: '150px', height: '150px' }"
            @remove="removeEvidence(index)"
          ></FilePreview>
        </FilePreviewListItem>
      </FilePreviewList>
    </div>
  </div>
</template>

<script>
import numberMixin from '@/mixins/number'
import {
  PaymentSummary,
  PaymentSummaryItem
} from '@/components/page/payment-summary'
import {
  PaymentMethod,
  PaymentMethodItem
} from '@/components/page/payment-method'
import { FileUpload } from '@/components/page/file-upload'
import {
  FilePreview,
  FilePreviewList,
  FilePreviewListItem
} from '@/components/page/file-preview'
import { NumberInput } from '@/components/form/number-input'

export default {
  components: {
    PaymentSummary,
    PaymentSummaryItem,
    PaymentMethod,
    PaymentMethodItem,
    FileUpload,
    FilePreview,
    FilePreviewList,
    FilePreviewListItem,
    NumberInput
  },

  mixins: [numberMixin],

  props: {
    amount: {
      type: Number,
      default: 0
    },

    discount: {
      type: [String, Number],
      default: ''
    },

    change: {
      type: Number,
      default: 0
    },

    invoice: {
      type: Boolean,
      default: false
    },

    methods: {
      type: Array,
      default: () => []
    },

    evidences: {
      type: Array,
      default: () => []
    },

    uploading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    localDiscount: {
      get() {
        return this.discount
      },
      set(value) {
        this.$emit('update:discount', value)
      }
    },

    localInvoice: {
      get() {
        return this.invoice
      },
      set(value) {
        this.$emit('update:invoice', value)
      }
    },

    fee() {
      return this.methods.reduce((prev, curr) => prev + curr.calculatedFee, 0)
    },

    total() {
      return this.amount - +this.discount
    },

    totalWithCharge() {
      return this.total + this.fee
    },

    receivedAmount() {
      return this.methods.reduce((prev, curr) => prev + curr.finalAmount, 0)
    },

    changeAmount() {
      const change = this.receivedAmount - this.totalWithCharge
      this.updateChange(change)
      return change
    }
  },

  methods: {
    addMethod() {
      this.$emit('add-method')
    },

    removeMethod(index) {
      this.$emit('remove-method', index)
    },

    removeEvidence(index) {
      this.$emit('remove-evidence', index)
    },

    upload(files) {
      this.$emit('upload', files)
    },

    updateChange(value) {
      this.$emit('update:change', value)
    }
  }
}
</script>

<style lang="scss" module>
.label {
  font-size: 1rem;
  font-weight: bold;

  &.isLarge {
    font-size: 1.25rem;
  }
}

.paymentInput {
  :global(.el-input__inner) {
    font-weight: bold;
    font-size: 1rem;
    text-align: right;
  }

  &.isLarge {
    :global(.el-input__inner) {
      font-size: 1.25rem;
    }
  }
}

.totalInput {
  :global(.el-input__inner) {
    border-color: $--color-primary;
  }
}
</style>

<style
  src="@/assets/scss/modules/element-ui.module.scss"
  lang="scss"
  module="elementUiStyles"
></style>
